import { backendDateOrDateTimeToLuxonDateTime } from "../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import type { ChangeableFieldData } from "../../../ChangeableFieldWidget/ChangeableFieldWidget";
import type { OperationPeriod } from "../ChangeableOperator";

export function convertOperatorsToChangeableFieldData(
  operators?: Array<OperationPeriod>
) {
  if (!operators) {
    return undefined;
  }

  return operators
    .map<ChangeableFieldData>((operator) => ({
      startDate: operator.first_date
        ? backendDateOrDateTimeToLuxonDateTime(operator.first_date)
        : null,
      endDate: operator.last_date
        ? backendDateOrDateTimeToLuxonDateTime(operator.last_date)
        : null,
      value: operator.company
    }))
    .sort((a, b) => {
      const dateA = a.startDate ?? new Date(0);
      const dateB = b.startDate ?? new Date(0);
      return dateA < dateB ? -1 : dateA > dateB ? 1 : 0;
    });
}
